import { render } from "./CardCookies.vue?vue&type=template&id=076bec22&scoped=true"
import script from "./CardCookies.vue?vue&type=script&lang=js"
export * from "./CardCookies.vue?vue&type=script&lang=js"

import "./CardCookies.vue?vue&type=style&index=0&id=076bec22&scoped=true&lang=less"

import exportComponent from "/Users/alex/Documents/Google Ads/Panorama Residence/Panorama web/panorama-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076bec22"]])

export default __exports__